import { render, staticRenderFns } from "./ViewSops.vue?vue&type=template&id=412a75bf&scoped=true&"
import script from "./ViewSops.vue?vue&type=script&lang=js&"
export * from "./ViewSops.vue?vue&type=script&lang=js&"
import style0 from "./ViewSops.vue?vue&type=style&index=0&id=412a75bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412a75bf",
  null
  
)

export default component.exports